import { Box, HStack, Text, useToken } from '@chakra-ui/react';

import { hexToRGBA } from '@/client/utils/hexToRGBA';

interface ExpertsNavigationItemProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  isActive: boolean;
}

export default function AiAgentAdminNavigationItem({
  label,
  icon,
  onClick,
  isActive,
}: ExpertsNavigationItemProps) {
  const [brandPrimary] = useToken('colors', ['brand.primary']);

  return (
    <Box
      paddingX={4}
      paddingY={2}
      backgroundColor={isActive ? hexToRGBA(brandPrimary, 0.1) : 'transparent'}
      borderRadius="8px"
      fontSize="14px"
      fontWeight={isActive ? 600 : 500}
      color="baseBlack"
      _hover={{
        cursor: 'pointer',
        backgroundColor: hexToRGBA(brandPrimary, 0.1),
      }}
      onClick={onClick}
    >
      <HStack>
        {icon}

        <Text>{label}</Text>
      </HStack>
    </Box>
  );
}
